var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconTrash = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4.98 3a3.07 3.07 0 0 1 .313-1.197C5.821.748 6.985 0 9 0c2.014 0 3.18.748 3.707 1.803.22.442.294.872.313 1.197H17a1 1 0 1 1 0 2h-1v10a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5H1a1 1 0 0 1 0-2h3.98ZM4 5v10a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V5H4Zm7.011-2a1.015 1.015 0 0 0-.093-.303C10.821 2.502 10.486 2 9 2s-1.82.502-1.918.697c-.05.099-.078.204-.093.303h4.022Z",
  clipRule: "evenodd"
})));
export default SvgIconTrash;